module.exports = __webpack_public_path__ + "static/media/javascript.b9ce6b5e.svg";